import React from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';
import type { ResizeCallbackData } from 'react-resizable';
import ResizableTitle from './ResizableTitle';
import './styles.css';

interface ResizableTableProps extends TableProps<any> {
  onColumnResize?: (key: string, width: number) => void;
}

const ResizableTable: React.FC<ResizableTableProps> = ({
  columns = [],
  onColumnResize,
  ...restProps
}) => {
  const handleResize = (key: string, minWidth?: number, maxWidth?: number) => 
    (_e: React.SyntheticEvent, { size }: ResizeCallbackData) => {
      if (onColumnResize) {
        onColumnResize(key, size.width);
      }
    };

  const mergedColumns = columns.map((col: any) => {
    if (!col.width || col.resizable === false) {
      return col;
    }

    return {
      ...col,
      onHeaderCell: (column: any) => ({
        width: column.width,
        minWidth: column.minWidth,
        maxWidth: column.maxWidth,
        onResize: handleResize(col.key || col.dataIndex, column.minWidth, column.maxWidth),
      }),
    };
  });

  return (
    <Table
      {...restProps}
      columns={mergedColumns}
      components={{
        header: {
          cell: ResizableTitle,
        },
      }}
    />
  );
};

export default ResizableTable;
